/**
 * @description to propagate click event after stop propagation, handling cases with closing popovers
 */
export function propagateTableEventClickManually(event: Event) {
  const el = event.target as HTMLElement;
  const table = el.closest('p-table');

  table?.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
    })
  );
}
